import type { MetodoTef } from "@/lib/tef/elgin"

export type MetodoPagamentoId = 'CREDIT' | 'DEBIT' | 'PIX'
export type TrilhaPagamento = 'cartao' | 'pix'
export type IconePagamento = 'credito' | 'debito' | 'pix'

export interface MetodoPagamento {
    id: MetodoPagamentoId
    rotulo: string
    metodoTef: MetodoTef
    trilha: TrilhaPagamento
    icone: IconePagamento
    cor: string
}

export const METODOS_PAGAMENTO: MetodoPagamento[] = [
    {
        id: 'CREDIT',
        rotulo: 'Crédito',
        metodoTef: 'CREDIT_CARD',
        trilha: 'cartao',
        icone: 'credito',
        cor: '#0D47A1',
    },
    {
        id: 'DEBIT',
        rotulo: 'Débito',
        metodoTef: 'DEBIT_CARD',
        trilha: 'cartao',
        icone: 'debito',
        cor: '#616161',
    },
    {
        id: 'PIX',
        rotulo: 'PIX',
        metodoTef: 'PIX',
        trilha: 'pix',
        icone: 'pix',
        cor: '#00BFA5',
    },
]